import { Skeleton } from "@capacit-com/lara-law-shared-ui";
import { ChevronDown, Edit2 } from "lucide-react";

const FeatureSkeleton = () => {
  return (
    <>
      <div className="flex flex-col" key={"skeleton-container"}>
        {Array.from({ length: 3 }).map((_, parentIndex) => (
          <div key={"skeleton-container-" + parentIndex}>
            <Skeleton
              key={"skeleton-header-" + parentIndex}
              className={`h-[28px] border w-24 mb-2 ${
                parentIndex !== 0 ? "mt-4" : ""
              }`}
            />
            {Array.from({ length: 6 }).map((_, index) => (
              <div
                className="rounded-lg border mb-2"
                key={"skeleton-row-" + parentIndex + "-" + index}
              >
                <div className="p-0">
                  <Skeleton className="flex flex-row justify-between items-center px-2">
                    <div className="p-2">
                      <Skeleton className="h-5 w-24" /> {/* "Grupper" title */}
                    </div>
                    <div className="flex flex-row gap-2 p-1.5">
                      <div className="size-8 p-2 rounded-md flex justify-center items-center">
                        <Edit2 className="size-4 animate-pulse" />
                      </div>{" "}
                      {/* Add button */}
                      <div className="size-8 py-2 px-1 rounded-md flex justify-center items-center">
                        <ChevronDown
                          className="animate-pulse"
                          style={{
                            width: "1.5rem",
                            height: "1.5rem",
                            strokeWidth: "1.5",
                          }}
                        />
                      </div>{" "}
                      {/* Expand button */}
                    </div>
                  </Skeleton>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default FeatureSkeleton;
